import { documentPackageSummarySchema, getDocumentPackageSummaryResponseSchema, } from '@consigli/types';
import { createParams, createTransformer, mapToSnakeCase, } from './shared/base-api';
export const documentPackageSummaryApiEndpoints = (builder, coreApiBaseUrl) => ({
    getDocumentPackageSummary: builder.query({
        query: ({ projectId, documentPackageId, categoryType }) => {
            const params = createParams({ category_type: categoryType });
            return {
                url: `${coreApiBaseUrl}/projects/${projectId}/packages/${documentPackageId}/summary/`,
                method: 'GET',
                params,
            };
        },
        transformResponse: createTransformer(getDocumentPackageSummaryResponseSchema, 'GetDocumentPackageSummary'),
        providesTags: (result, error, { documentPackageId }) => [
            { type: 'DocumentPackageSummary', id: documentPackageId },
            'DocumentPackageSummary',
        ],
    }),
    createDocumentPackageSummary: builder.mutation({
        query: ({ projectId, documentPackageId, description, sections }) => ({
            url: `${coreApiBaseUrl}/projects/${projectId}/packages/${documentPackageId}/summary/`,
            method: 'POST',
            body: mapToSnakeCase({
                description,
                sections: sections.map((s) => mapToSnakeCase(s)),
            }),
        }),
        transformResponse: createTransformer(documentPackageSummarySchema, 'CreateDocumentPackageSummary'),
        invalidatesTags: (result, error, { documentPackageId }) => [
            { type: 'DocumentPackageSummary', id: documentPackageId },
            'DocumentPackageSummary',
        ],
    }),
    updateDocumentPackageSummary: builder.mutation({
        query: ({ projectId, documentPackageId, summaryId, description, sections }) => ({
            url: `${coreApiBaseUrl}/projects/${projectId}/packages/${documentPackageId}/summary/${summaryId}/`,
            method: 'PUT',
            body: mapToSnakeCase({
                description,
                sections: sections.map((s) => mapToSnakeCase(s)),
            }),
        }),
        transformResponse: createTransformer(documentPackageSummarySchema, 'UpdateDocumentPackageSummary'),
        invalidatesTags: (result, error, { documentPackageId }) => [
            { type: 'DocumentPackageSummary', id: documentPackageId },
            'DocumentPackageSummary',
        ],
    }),
    deleteDocumentPackageSummary: builder.mutation({
        query: ({ projectId, documentPackageId, summaryId }) => ({
            url: `${coreApiBaseUrl}/projects/${projectId}/packages/${documentPackageId}/summary/${summaryId}/`,
            method: 'DELETE',
        }),
        invalidatesTags: (result, error, { documentPackageId }) => [
            { type: 'DocumentPackageSummary', id: documentPackageId },
            'DocumentPackageSummary',
        ],
    }),
});
